import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller } from "react-hook-form";
import { TextField } from '@material-ui/core';

export default function cityControl(control: any, errors: any, shrink?: boolean) {
    const { t } = useTranslation();

    let label;
    if (errors.city?.type === 'required' || errors.city?.type === 'pattern') {
        label = (
            <>
                {t('City')}
                <div className='errorLabelAsterisk'>*</div>
            </>
        );
    } else {
        label = t('City');
    }

    return (
        <Controller
            as={TextField}
            control={control}
            defaultValue=""
            name="city"
            rules={{
                required: true,
                pattern: /^[a-zA-Z\s]+(?:[\s-][a-zA-Z\s]+)*$/
            }}
            fullWidth
            id="city"
            label={label}
            error={errors.city?.type === "required" || errors.city?.type === "pattern"}
            helperText=
            {(errors.city?.type === "required" && t("City is required")) ||
            (errors.city?.type === "pattern" && t("City is incorrect")) ||
            (true && " ")}
            InputLabelProps={{
                shrink: shrink,
                error: false,
            }}
        />);
}
